import { Alert, Checkbox, Col, Drawer, Modal, Row } from "antd";
import React, { useEffect, useState } from "react";
import { ObtenerGruposMontajeMarcasTecdocEnAPI, ObtenerListaMarcasTecdocEnAPI, abortFetch } from "../../action/actionCreatorsRequests";
import CPSelect from "../Utils/CPSelect";
import { MSGERROR, dynamicSortAsc, dynamicSortDesc, traducirPagina } from "../../librerias/funciones";
import { ArrowLeftOutlined, ArrowRightOutlined, CalculatorOutlined, CloseOutlined } from "@ant-design/icons";
import CPSearch from "../Utils/CPSearch";
import CheckboxGroup from "antd/lib/checkbox/Group";

const FichaNuevoCruceMarcas = ({ abrirFicha = false, cerrarFicha = () => { }, titulo = "", calcularCruce = () => { } }) => {
    const [selectMarcas, setSelectMarcas] = useState({
        id: undefined,
        registros: [],

        registrosMarcas: [],
        marcasSeleccionadas: [],
        textoFiltroMarca: ""
    })
    const [grupos, setGrupos] = useState({
        id: undefined,
        registros: [],
        seleccionados: [],
        textoFiltro: ""
    })


    const [modalCompra, setModalCompra] = React.useState({
        ABRIR_MODAL: false,
        REGISTRO_SELECCIONADO: {},
        LOADER_PEDIDO: false,
        RESPUESTA_PEDIDO: ""

    });


    const [bloqueoPantalla, setBloqueoPantalla] = useState({ LOADER: false, MENSAJE: "" })

    const [activeTabMenu, setActiveTabMenu] = useState(1);

    const buscarMarcas = async () => {

        const marcas = await ObtenerListaMarcasTecdocEnAPI(0, 1, 1, "A", null)

        if (marcas !== undefined && marcas.REGISTROS !== null && marcas.REGISTROS.length > 0) {
            selectMarcas.registros = marcas.REGISTROS.map((item) => { return { ID: item.ID, DESCRIPCION: item.MARCA } })

            selectMarcas.registrosMarcas = marcas.REGISTROS.map((item, i) => { return { value: item.ID, SELECCIONADO: false, VISIBLE: true, label: item.MARCA } })

            setSelectMarcas({ ...selectMarcas })
        }
    }

    const buscarGruposMontaje = async (ID_MARCA) => {

        grupos.registros = []
        grupos.seleccionados = []
        setGrupos({ ...grupos })

        if (ID_MARCA !== undefined) {
            const respuesta = await ObtenerGruposMontajeMarcasTecdocEnAPI(ID_MARCA)

            if (respuesta !== undefined && respuesta.REGISTROS !== null && respuesta.REGISTROS.length > 0) {

                //grupos.registros = respuesta.REGISTROS.map((item, i) => { return { ID: item.ID, SELECCIONADO: false, VISIBLE: true, NOMBRE: item.NOMBRE } })
                grupos.registros = respuesta.REGISTROS.map((item, i) => { return { value: item.ID, SELECCIONADO: false, VISIBLE: true, label: item.NOMBRE } })

                setGrupos({ ...grupos })
            }
        }

    }

    const registrosUnicos = (registros) => {
        let registrosSinDuplicar = registros.filter((elemento, index) => {
            return registros.indexOf(elemento) === index;
        });
        return registrosSinDuplicar;
    }

    const evento_checked_grupo = (checkedValues) => {

        grupos.seleccionados = [...grupos.seleccionados, ...checkedValues]
        setGrupos({ ...grupos })
    }


    const evento_checked_marcas = (checkedValues) => {
        selectMarcas.marcasSeleccionadas = [...checkedValues]
        setSelectMarcas({ ...selectMarcas })
    }

    const evento_checked_grupov2 = (e) => {
        const { value, checked } = e.target
        if (checked) {
            grupos.seleccionados = [...grupos.seleccionados, value]
        } else {
            grupos.seleccionados = grupos.seleccionados.filter((item) => item !== value)
        }

        setGrupos({ ...grupos })
    }

    const evento_checked_marcasv2 = (e) => {
        const { value, checked } = e.target
        if (checked) {
            selectMarcas.marcasSeleccionadas = [...selectMarcas.marcasSeleccionadas, value]
        } else {
            selectMarcas.marcasSeleccionadas = selectMarcas.marcasSeleccionadas.filter((item) => item !== value)
        }

        setSelectMarcas({ ...selectMarcas })
    }

    const filtroLocalRegistros = (textoAFiltrar, registros) => {
        let resultado = []
        if (textoAFiltrar !== undefined && textoAFiltrar !== "") {
            if (registros !== undefined && registros !== null && registros.length > 0) {
                let resultadoFiltro = registros.filter((item) => {
                    return item.label.toUpperCase().includes(textoAFiltrar.toUpperCase()) ||
                        item.label.toUpperCase() === textoAFiltrar.toUpperCase()
                })

                if (resultadoFiltro.length > 0) {
                    resultado = resultadoFiltro
                }
            }
        } else {
            resultado = registros;
        }

        return resultado
    }


    const gestionarCruce = async () => {
        let MARCAS_DESTINO = ""
        let GRUPOS_DESTINO = ""
        console.log("grupos.seleccionados", grupos.seleccionados)

        GRUPOS_DESTINO = registrosUnicos(grupos.seleccionados).join(";")
        MARCAS_DESTINO = registrosUnicos(selectMarcas.marcasSeleccionadas).join(";")

        modalCompra.ABRIR_MODAL = true
        modalCompra.LOADER_PEDIDO = true
        setModalCompra({ ...modalCompra })

        let respuesta = await calcularCruce(selectMarcas.id, GRUPOS_DESTINO, MARCAS_DESTINO)

        if (respuesta === undefined || respuesta === null) {
            modalCompra.RESPUESTA_PEDIDO = traducirPagina("Peticion_terminada");

        } else {
            if (respuesta.OK) {

                modalCompra.RESPUESTA_PEDIDO = traducirPagina("Cruce_ralizado");

                cerrarFicha(false)

            } else {
                modalCompra.RESPUESTA_PEDIDO = respuesta.MENSAJE_ERROR;
            }
        }

        modalCompra.LOADER_PEDIDO = false
        setModalCompra({ ...modalCompra })


    }


    useEffect(() => {
        buscarMarcas()
    }, [])


    return (
        <>
            <Drawer
                width={700}
                /*onClose={() => { cerrarFicha(false) }}*/
                visible={abrirFicha}
                placement={"right"}
                closable={false}
                bodyStyle={{ padding: '0px' }}
                style={{ color: '#fff' }}
            >

                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => { cerrarFicha(false) }}></CloseOutlined>
                        <div> {titulo}</div>
                    </div>
                </div>


                <div className='containerInfoProveedor' style={{ height: 'calc(100vh - 61px)' }}>
                    <div className='headerTab'>
                        <div className={`itemTabRegistro  ${activeTabMenu === 1 ? "activeItemTab" : "disabledItemTab"}`} onClick={() => { setActiveTabMenu(1) }}>{traducirPagina("Datos").toUpperCase()}</div>
                        <div className={`itemTabRegistro  ${activeTabMenu === 2 ? "activeItemTab" : "disabledItemTab"}`} onClick={() => { setActiveTabMenu(2) }}>{traducirPagina("Label_cruce").toUpperCase()}</div>
                        <div className={`itemTabRegistro  ${activeTabMenu === 3 ? "activeItemTab" : "disabledItemTab"}`} onClick={() => { setActiveTabMenu(3) }}>{traducirPagina("Calcular").toUpperCase()}</div>
                    </div>


                    <div className={`bodyTab`} style={{ height: 'calc(100% - 100px)', padding: '20px 20px 0px 20px' }}>
                        <div className={activeTabMenu === 1 && "activeBodyTab"}>
                            <div className="containerImportacionNeumatico" style={{ height: 'auto' }}>
                                <div>
                                    <div className='tituloCatalogoNeumatico'>
                                        <span>{`1. ${traducirPagina("Seleccion_marca")}`} </span>
                                    </div>

                                    <div className='bodyCatalogoNeumatico'>
                                        <CPSelect
                                            placeholder={traducirPagina("Seleccion_marca")}
                                            registers={selectMarcas.registros}
                                            value={selectMarcas.id}
                                            onChange={(e) => {
                                                selectMarcas.id = e
                                                setSelectMarcas({ ...selectMarcas })
                                                buscarGruposMontaje(selectMarcas.id)
                                            }}

                                        />
                                        <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999', display: 'block' }}>{traducirPagina("txt_marca_grupo")}</span>

                                    </div>
                                </div>

                                <div>
                                    {
                                        selectMarcas.id !== undefined && (
                                            <div className='tituloCatalogoNeumatico'>
                                                <span>{`2. ${traducirPagina("Msg_filtro_un_grupo_marca")}`} </span>
                                            </div>
                                        )
                                    }

                                    <div className='bodyCatalogoNeumatico'>
                                        {
                                            selectMarcas.id !== undefined && (
                                                <>
                                                    <div className="continaer_buscador">
                                                        <CPSearch
                                                            textoBuscador={grupos.textoFiltro}
                                                            onChangeInput={(e) => {
                                                                grupos.textoFiltro = e.target.value
                                                                setGrupos({ ...grupos })
                                                            }}
                                                            onCloseInput={(e) => {
                                                                grupos.textoFiltro = ""
                                                                setGrupos({ ...grupos })
                                                            }}
                                                            className="buscardor_grupo_marcas"
                                                        />
                                                    </div>

                                                    <div className="container_info_seleccionados">

                                                    </div>
                                                </>
                                            )}
                                        <div className='containerGrupoReferencias'>
                                            {
                                                selectMarcas.id !== undefined && (
                                                    grupos.registros === null ?
                                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                        :
                                                        grupos.registros !== null && grupos.registros.length > 0 ?
                                                            <div className='container_list_grupo'>
                                                                {/*
                                                                <CheckboxGroup
                                                                    options={filtroLocalRegistros(grupos.textoFiltro, grupos.registros)}
                                                                    value={grupos.seleccionados}
                                                                    onChange={evento_checked_grupo}
                                                                    className="container_list_grupo listado_cruce_marcas"
                                                                />

                                                */}
                                                

                                        
                                                            <Checkbox.Group
                                                                className="container_list_grupo listado_cruce_marcas"
                                                            >
                                                                {
                                                                    filtroLocalRegistros(grupos.textoFiltro, grupos.registros).map((item) =>

                                                                        <Checkbox
                                                                            value={item.value}
                                                                            onChange={(e) => {

                                                                                evento_checked_grupov2(e)
                                                                            }}
                                                                        >
                                                                            {item.label}
                                                                        </Checkbox>
                                                                    )
                                                                }
                                                            </Checkbox.Group>



                                                            </div>
                                                            :
                                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>

                                                )
                                            }
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>

                        <div className={activeTabMenu === 2 && "activeBodyTab"}>

                            <div className="containerImportacionNeumatico" style={{ height: 'auto' }}>
                                <div>
                                    <div className='tituloCatalogoNeumatico'>
                                        <span>{`3. ${traducirPagina("Msg_filtro_indique_marca")}`} </span>
                                    </div>

                                    <div className='bodyCatalogoNeumatico'>
                                        {
                                            selectMarcas.id !== undefined && (
                                                <>
                                                    <div className="continaer_buscador">
                                                        <CPSearch
                                                            textoBuscador={selectMarcas.textoFiltroMarca}
                                                            onChangeInput={(e) => {
                                                                selectMarcas.textoFiltroMarca = e.target.value
                                                                setSelectMarcas({ ...selectMarcas })
                                                            }}
                                                            onCloseInput={(e) => {
                                                                selectMarcas.textoFiltroMarca = ""
                                                                setSelectMarcas({ ...selectMarcas })

                                                            }}
                                                            className="buscardor_grupo_marcas"
                                                        />
                                                    </div>

                                                    <div className="container_info_seleccionados">

                                                    </div>
                                                </>
                                            )}
                                        <div className='containerGrupoReferenciasMarcas'>
                                            {

                                                selectMarcas.registrosMarcas === null ?
                                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                    :
                                                    selectMarcas.registrosMarcas !== null && selectMarcas.registrosMarcas.length > 0 ?
                                                        <div className=''>
                                                            <Checkbox.Group
                                                                className="container_list_grupo_marcas listado_cruce_marcas"
                                                            >
                                                                {
                                                                    filtroLocalRegistros(selectMarcas.textoFiltroMarca, selectMarcas.registrosMarcas).map((item) =>

                                                                        <Checkbox
                                                                            value={item.value}
                                                                            onChange={(e) => {

                                                                                evento_checked_marcasv2(e)
                                                                            }}
                                                                        >
                                                                            {item.label}
                                                                        </Checkbox>
                                                                    )
                                                                }
                                                            </Checkbox.Group>
                                                            {/* 
                                                            <CheckboxGroup
                                                                options={filtroLocalRegistros(selectMarcas.textoFiltroMarca, selectMarcas.registrosMarcas)}
                                                                value={selectMarcas.marcasSeleccionadas}
                                                                onChange={evento_checked_marcas}
                                                                className="container_list_grupo_marcas listado_cruce_marcas"
                                                            />
                                                            */}
                                                        </div>
                                                        :
                                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '20vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>


                                            }
                                        </div>
                                    </div>




                                </div>


                            </div>
                        </div>

                        <div className={activeTabMenu === 3 && "activeBodyTab"}>

                            <Alert
                                message={traducirPagina("Info_cruce")}
                                description={
                                    <div>
                                        <div className="separador_label_cruce">{traducirPagina("info_grupo_montaje_1")}</div>

                                        <div className="separador_label_cruce">  <b>{traducirPagina("info_grupo_montaje_2")}</b></div>

                                        <div>  <b>{traducirPagina("info_grupo_montaje_3")}</b> </div>
                                    </div>
                                }
                                type="info"
                                showIcon
                                className="personalizar_alert_grupo_montaje" />


                            <div className="containerImportacionFinal" style={{ height: 'auto' }}>
                                <div>
                                    <div className='tituloCatalogoNeumatico'>
                                        <span>{`${traducirPagina("Marca_origen")}`} </span>
                                    </div>

                                    <div className='bodyCatalogoNeumatico'>
                                        {
                                            selectMarcas.id !== undefined && (
                                                selectMarcas.registros.find((item) => item.ID === selectMarcas.id).DESCRIPCION
                                            )
                                        }

                                    </div>
                                </div>

                                <div>
                                    <div className='tituloCatalogoNeumatico'>
                                        <span>{`${traducirPagina("Grupo_montaje")}`} </span>
                                    </div>

                                    <div className='bodyCatalogoNeumatico'>
                                        {
                                            grupos.seleccionados.length > 0 && (
                                                <ul className="listado_seleccionados_grupo">
                                                    {grupos.registros.filter((registro) => grupos.seleccionados.includes(registro.value)).map((item, i) =>
                                                        <li key={i} >
                                                            {item.label}

                                                        </li>
                                                    )}
                                                </ul>
                                            )
                                        }
                                    </div>
                                </div>

                                <div>
                                    <div className='tituloCatalogoNeumatico'>
                                        <span>{`${traducirPagina("Marcas_destino")}`} </span>
                                    </div>

                                    <div className='bodyCatalogoNeumatico'>
                                        {
                                            selectMarcas.marcasSeleccionadas.length > 0 && (
                                                <ul className="listado_seleccionados_grupo">
                                                    {selectMarcas.registrosMarcas.filter((registro) => selectMarcas.marcasSeleccionadas.includes(registro.value)).map((item, i) =>
                                                        <li key={i} >
                                                            {item.label}
                                                        </li>
                                                    )}
                                                </ul>
                                            )
                                        }
                                    </div>
                                </div>

                            </div>




                            {/*
                            ERRORES ?
                                <>
                                    <Alert
                                        style={{ marginBottom: '20px' }}
                                        message="Información"
                                        description={<div style={{ fontSize: '18px' }}>{traducirPagina("label_actualizacion_registro")}  </div>}
                                        type="warning"
                                        showIcon
                                    />

                                    <div style={{ margin: '20px 5px', fontSize: '16px', fontWeight: '400' }}>
                                        <p>{traducirPagina("label_registro_detectado")}
                                            <b>{` ${TOTAL_ERRORES} ${traducirPagina("label_registro_sin_importar")}, `}</b>  {traducirPagina("label_descargar_registro")}

                                            <span class="ver_mas_info" style={{ marginTop: '10px' }} onClick={() => {
                                                if (CSV !== "" && CSV !== null) {
                                                    descargarDocPasandoBase64Generico(CSV, "csv")
                                                }

                                            }}><span>{" enlace."}</span></span>
                                        </p>
                                    </div>
                                </>
                                :
                                <Alert
                                    style={{ marginBottom: '20px' }}
                                    message="Información"
                                    description={<div style={{ fontSize: '18px' }}>{traducirPagina("label_registro_actualizados")}</div>}
                                    type="success"
                                    showIcon
                                />
                                        */ }

                        </div>

                    </div>

                    {
                        <div className="footerCruceMarcas" style={{ justifyContent: 'space-between' }}>
                            {
                                activeTabMenu === 1 ?
                                    <>
                                        <div disabled={bloqueoPantalla.LOADER} className="botonNuevo" style={{ backgroundColor: 'var(--amarillo-serca)', color: 'var(--azul-claro-serca)' }}
                                            onClick={() => {
                                                cerrarFicha(false)
                                            }}>
                                            <CloseOutlined /> {traducirPagina("Salir")}
                                        </div>

                                        <div disabled={bloqueoPantalla.LOADER} className="botonNuevo" style={{ backgroundColor: 'var(--azul-claro-serca)', color: '#fff' }}
                                            onClick={() => {

                                                if (selectMarcas.id === undefined || grupos.seleccionados.length === 0) {
                                                    MSGERROR(traducirPagina("Msg_cruce_continuar"))
                                                } else {
                                                    setActiveTabMenu(2)
                                                }
                                            }}>
                                            <ArrowRightOutlined /> {traducirPagina("Continuar")}
                                        </div>
                                    </>

                                    :
                                    activeTabMenu === 2 ?

                                        <>
                                            <div disabled={bloqueoPantalla.LOADER} className="botonNuevo" style={{ backgroundColor: 'var(--amarillo-serca)', color: 'var(--azul-claro-serca)' }}
                                                onClick={() => {
                                                    setActiveTabMenu(1);
                                                    grupos.textoFiltro = ""
                                                    setGrupos({ ...grupos })
                                                }}>
                                                <ArrowLeftOutlined /> {traducirPagina("Volver_atras")}
                                            </div>

                                            <div disabled={bloqueoPantalla.LOADER} className="botonNuevo" style={{ backgroundColor: 'var(--azul-claro-serca)', color: '#fff' }}
                                                onClick={() => {

                                                    if (selectMarcas.marcasSeleccionadas.length === 0) {
                                                        MSGERROR(traducirPagina("Msg_seleccion_marcas"))
                                                    } else {
                                                        setActiveTabMenu(3)
                                                    }

                                                }}>
                                                <ArrowRightOutlined /> {traducirPagina("Continuar")}
                                            </div>
                                        </>
                                        :


                                        <>
                                            <div disabled={bloqueoPantalla.LOADER} className="botonNuevo" style={{ backgroundColor: 'var(--amarillo-serca)', color: 'var(--azul-claro-serca)' }}
                                                onClick={() => {
                                                    setActiveTabMenu(2);
                                                    selectMarcas.textoFiltroMarca = ""
                                                    setSelectMarcas({ ...selectMarcas })
                                                }}>
                                                <ArrowLeftOutlined /> {traducirPagina("Volver_atras")}
                                            </div>

                                            <div disabled={bloqueoPantalla.LOADER} className="botonNuevo" style={{ backgroundColor: 'var(--azul-claro-serca)', color: '#fff' }}
                                                onClick={() => {
                                                    gestionarCruce()

                                                }}>
                                                <CalculatorOutlined /> {traducirPagina("Calcular")}
                                            </div>
                                        </>
                            }
                        </div>
                    }

                </div>


                {modalCompra.ABRIR_MODAL ?
                    <Modal
                        visible={modalCompra.ABRIR_MODAL}
                        style={{ zIndex: "9999" }}
                        width={700}
                        centered
                        afterClose={() => {
                            setModalCompra({
                                ABRIR_MODAL: false,
                                REGISTRO_SELECCIONADO: {},
                                LOADER_PEDIDO: false,
                                RESPUESTA_PEDIDO: ""
                            })

                        }}
                        title={traducirPagina("Msg_cruce_referencia_grupo")}
                        onCancel={() => {
                            if (!modalCompra.LOADER_PEDIDO) {
                                modalCompra.ABRIR_MODAL = false
                                modalCompra.REGISTRO_SELECCIONADO = {}
                                modalCompra.LOADER_PEDIDO = false
                                modalCompra.RESPUESTA_PEDIDO = ""

                                setModalCompra({ ...modalCompra })
                            }
                        }}
                        footer={[
                            <div className='btn_cruceReferencia_alert' onClick={() => { abortFetch() }}>
                                {traducirPagina("Cancelar_peticion")}
                            </div>
                        ]}>

                        <Row style={{ color: '#000', fontSize: '18px', fontWeight: '500' }}>
                            <Col md={24} className="mb-2">
                                <span style={{ color: '#000' }}>{
                                    modalCompra.RESPUESTA_PEDIDO === "" ?
                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '10vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled />  {`${traducirPagina("Msg_generando_cruce")} ...`} </div>
                                        :
                                        modalCompra.RESPUESTA_PEDIDO

                                }</span>
                                <br></br>



                            </Col>
                        </Row>
                    </Modal>
                    :
                    null
                }




            </Drawer>
        </>
    )

}

export default FichaNuevoCruceMarcas;